import React from 'react';
import PropTypes from 'prop-types';
import { CMS } from '../../utils/CMS';
import { FlightClassSelectorItem } from './FlightClassSelectorItem';
import { FlightClass, FlightClassCMS, FlightClassProp } from '../../models/FlightClass';
import { ConnectedFlightClassSelector } from './FlightClassSelector';
import { BoxLayer } from '../../components/Box';
import { Dropdown } from '../../components/Dropdown/Dropdown';

const FlightClassSelectorInner = ({ onChange, value }) => {
    const node = React.useRef(null);
    const [open, setOpen] = React.useState(false);
    const toggle = () => setOpen(!open);
    const arrowType = open ? 'odf-icon-arrow-up' : 'odf-icon-arrow-down';

    const items = Object.keys(FlightClass);

    const onChangeWrapper = (newValue) => {
        setOpen(false);
        onChange(newValue);
    };

    return (
        <div className="odf-space-outer-right-m" ref={node}>
            <div onClick={toggle}>
                <span className="odf-link">
                    <CMS id={FlightClassCMS[value]} />
                </span>
                <span className={`odf-text-action odf-icon odf-space-inner-left-xs odf-icon-s ${arrowType}`} />
            </div>
            <Dropdown open={open} onClose={() => setOpen(false)} parentRef={node}>
                <BoxLayer className="odf-popup odf-popup-flex opened">
                    <ul>
                        { items.map((flightClass) => (
                            <FlightClassSelectorItem
                                key={flightClass}
                                value={flightClass}
                                isSelected={flightClass === value}
                                onChange={onChangeWrapper}
                            />
                        )) }
                    </ul>
                </BoxLayer>
            </Dropdown>
        </div>
    );
};

FlightClassSelectorInner.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: FlightClassProp.isRequired,
};

export const FlightClassSelector = () => (
    <ConnectedFlightClassSelector render={({ onChange, value }) => (
        <FlightClassSelectorInner onChange={onChange} value={value} />
    )}
    />
);
